import React from "react"
import { ButtonBase } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { useHistory } from "react-router-dom"

const useStyles = makeStyles(theme => ({
  button: {
    backgroundColor: "#C8C8C8",
    "&:hover": {
      backgroundColor: "#ABABAB",
    },
    width: "204px",
    height: "55px",
    fontFamily: "HiraKakuProN-W6, Hiragino Kaku Gothic ProN",
    fontSize: "16px",
    color: "#181818",
    fontWeight: 600,
    borderRadius: "5px",
  },
}))
const BackButton = ({ disabled, title, mode }) => {
  const classes = useStyles()
  const history = useHistory()
  const handleClickButton = event => {
    if (
      (mode === "back" || mode === "close" || mode === "") &&
      window.history.length > 1
    ) {
      history.goBack()
    } else {
      window.close()
    }
  }
  return (
    <ButtonBase
      id="backButton"
      disabled={disabled}
      onClick={handleClickButton}
      className={classes.button}
    >
      {title}
    </ButtonBase>
  )
}

export default BackButton
